import { createAsyncIcon } from '../../_factory/createAsyncIcon';

const AsyncPhosphorIconThin = createAsyncIcon(() => import('./PhosphorIconThin'));

export default AsyncPhosphorIconThin;

AsyncPhosphorIconThin.displayName = 'AsyncPhosphorIconThin';
